module.exports = __webpack_public_path__ + "static/media/singup-bg.21fb7fc1.jpg";